/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteConfigurationMutationVariables = Types.Exact<{
  input: Types.DeleteConfigurationsInput;
}>;


export type DeleteConfigurationMutation = { __typename: 'Mutation', deleteConfiguration: string };


export const DeleteConfigurationDocument = gql`
    mutation DeleteConfiguration($input: DeleteConfigurationsInput!) {
  deleteConfiguration(input: $input)
}
    `;
export type DeleteConfigurationMutationFn = ApolloReactCommon.MutationFunction<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>;

/**
 * __useDeleteConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConfigurationMutation, { data, loading, error }] = useDeleteConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>(DeleteConfigurationDocument, options);
      }
export type DeleteConfigurationMutationHookResult = ReturnType<typeof useDeleteConfigurationMutation>;
export type DeleteConfigurationMutationResult = ApolloReactCommon.MutationResult<DeleteConfigurationMutation>;
export type DeleteConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>;